import { defineComponent as _defineComponent } from 'vue'
import { dataNameProp, filterListToOptions, sequence } from '@/ui/helpers';
  import { Loader } from '@/ui/components/Loader';
  import { Box } from '@/ui/components/Box';
  import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
  import { t } from '@/ui/i18n/i18n';
  import BulkDeleteButton from '@/ui/components/button/BulkDeleteButton.vue';
  import { useBulkDeletable } from '@/ui/pages/useBulkDeletable';
  import { bulkDelete, list as getEntityItemList, remove } from '@/services/api/resources/entityItem';
  import { EntityItemList, EntityItemRecord } from '@/entities/entityItem';
  import { emptyList } from '@/services/api';
  import { usePagination, useSorting, useTask } from '@/ui/concerns';
  import { filter as getAllUsers } from '@/services/api/resources/user';
  import { get as getEntityType } from '@/services/api/resources/entityType';
  import { list as getEntityTypeProperties } from '@/services/api/resources/entityTypeProperty/actions';
  import { SelectOptions, SortDirection } from '@/ui/types';
  import * as qs from '@/ui/queryState';
  import { InputField } from '@/ui/components/form';
  import { updateMultiple } from '@/ui/queryState';
  import { BulkDeletableTable } from '@/ui/components/table/BulkDeletableTable';
  import { TagField } from '@/ui/components/form/TagField';
  import ListTruncatedCell from '@/ui/components/table/ListTruncatedCell.vue';
  import { Pagination } from '@/ui/components/Pagination';
  import { EntityTypeProperty } from '@/entities/entityTypeProperty';
  import { EntityTypeDetail } from '@/entities/entityType';
  import { PageTitle } from '@/ui/components/PageTitle';
  import { RedirectButton } from '@/ui/components/button/RedirectButton';
  import { getPropertyValue } from '@/ui/helpers/entityPropertiesHelper';
  import { Icon } from '@/ui/components/icon/Icon';
  import { router } from '@/ui/routes';
  import { queryTabName, EntityItemsTabNames } from '@/ui/components/navigation/constants';
  import EntityTypeItemsEmpty from './EntityTypeItemsEmpty.vue';
  import { isEntitiesUploadEnabled } from '@/ui/helpers/featureHelper';
  import EntitiesUploadModal from '@/ui/components/entityItem/EntitiesUploadModal.vue';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { Button } from '@/ui/components/Button';
  import emitter from '@/services/emitter';
  import { useModal } from '@/ui/concerns/modals/useModal';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EntityTypeItemsPage',
  props: {
    typeId: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const entityType = ref<EntityTypeDetail | null>(null);
  const entityTypeProperties = ref<EntityTypeProperty[]>([]);
  const users = ref<SelectOptions>([]);

  const { page, perPage, resetPagination } = usePagination();
  const { sort, dir } = useSorting('createdAt', SortDirection.Descending);

  const search = qs.string('search', '');
  const userFilter = qs.numbers('user', []);

  const getTypeTask = useTask(
    () => sequence(getEntityType(props.typeId), getEntityTypeProperties(props.typeId)),
    ([entityTypeResult, propertiesResult]) => {
      entityType.value = entityTypeResult.data;
      if (propertiesResult && propertiesResult.data) {
        entityTypeProperties.value = propertiesResult.data;
      }
    },
  );

  const getFilters = useTask(
    () => getAllUsers(),
    userList => {
      users.value = filterListToOptions(userList);
    },
  );

  const list = ref<EntityItemList>(emptyList());
  const getList = useTask(
    () => getEntityItemList({
      page: page.value,
      perPage: perPage.value,
      search: search.value,
      entityType: [props.typeId],
      entityFolder: [],
      user: userFilter.value,
      sort: sort.value,
      dir: dir.value,
    }),
    listResponse => {
      list.value = listResponse;
    },
  );

  watch([
    page,
    perPage,
    search,
    userFilter,
    sort,
    dir,
  ], getList.run);

  onMounted(() => {
    emitter.on('reloadEntityItems', getList.run);
  });

  onBeforeUnmount(() => {
    emitter.off('reloadEntityItems', getList.run);
  });

  const { selectedResources, deleteBulkTask, onCheckedRowsUpdate } = useBulkDeletable({
    getList,
    bulkDeleteFn: bulkDelete,
  });

  const isDeleteBulkTaskPending = computed(() => deleteBulkTask.state.value.pending);

  const hasEntityItems = computed(() => list.value.data.length > 0);

  const updateSearch = (value: string) => updateMultiple(() => {
    resetPagination();
    search.value = value;
  }, true);

  const updateUserFilter = (value: number[]) => updateMultiple(() => {
    resetPagination();
    userFilter.value = value;
  }, true);

  const isRowCheckable = (row: EntityItemRecord) => row.authorizedTo.delete;

  const getTitle = (row: EntityItemRecord) => {
    return row.data.title || t('checklist.no-title');
  };

  const getUsersText = (row: EntityItemRecord) => {
    return row.data.users.map(dataNameProp).join(', ');
  };

  const goBack = () => {
    router.push({
      name: 'entityItems',
      query: { [queryTabName]: EntityItemsTabNames.TYPES },
    });
  };

  const entitiesUploadEnabled = isEntitiesUploadEnabled();
  const [isImportModalOpen, openImportModal, closeImportModal] = useModal();

return { __sfc: true,props, entityType, entityTypeProperties, users, page, perPage, resetPagination, sort, dir, search, userFilter, getTypeTask, getFilters, list, getList, selectedResources, deleteBulkTask, onCheckedRowsUpdate, isDeleteBulkTaskPending, hasEntityItems, updateSearch, updateUserFilter, isRowCheckable, getTitle, getUsersText, goBack, entitiesUploadEnabled, isImportModalOpen, openImportModal, closeImportModal, Loader, Box, BulkDeleteButton, remove, InputField, BulkDeletableTable, TagField, ListTruncatedCell, Pagination, PageTitle, RedirectButton, getPropertyValue, Icon, EntityTypeItemsEmpty, EntitiesUploadModal, Tooltip, Button }
}

})